/* eslint-disable @typescript-eslint/no-confusing-void-expression */
import React from "react";
import { Button, Flex, InputNumber } from "antd";
import { type RowColumnProps } from "./type";
import { useTranslation } from "react-i18next";
import { formatTranslation } from "../../../shared/utils/translationUtils";
import { restrictToIntegersOnly } from "../../../pages/create-protocol/utils";

const MATRIX = {
  ROW: 99,
  COLUMN: 99,
};
const RowColumn: React.FC<RowColumnProps> = ({ inputValue, setInputValue }) => {
  const { t } = useTranslation();
  const handleIncrement = (field: keyof typeof inputValue): void => {
    setInputValue((prevState) => ({
      ...prevState,
      [field]: prevState[field] + 1,
    }));
  };

  const handleDecrement = (field: keyof typeof inputValue): void => {
    setInputValue((prevState) => ({
      ...prevState,
      [field]: Math.max(0, prevState[field] - 1),
    }));
  };

  return (
    <Flex vertical={false} gap={12}>
      <div>
        <label htmlFor="Rows">{formatTranslation(t("newTrial.rows"))}</label>
        <div className="input-main">
          <Button
            data-testid="minus-button-rows"
            onClick={() => {
              handleDecrement("rows");
            }}
            disabled={!inputValue.rows}
          >
            -
          </Button>
          <InputNumber
            data-testid="row-input"
            value={inputValue.rows}
            min={0}
            max={MATRIX.ROW}
            precision={0}
            onChange={(value) => {
              value && setInputValue({ ...inputValue, rows: value });
            }}
            onKeyDown={(e: any) => {
              restrictToIntegersOnly(e);
            }}
            controls={false}
          />
          <Button
            data-testid="plus-button-rows"
            disabled={inputValue.rows >= MATRIX.ROW}
            onClick={() => {
              handleIncrement("rows");
            }}
          >
            +
          </Button>
        </div>
      </div>
      <div>
        <label htmlFor="Columns">
          {formatTranslation(t("shared.columns"))}
        </label>
        <div className="input-main">
          <Button
            data-testid="minus-button-columns"
            onClick={() => {
              handleDecrement("columns");
            }}
            disabled={!inputValue.columns}
          >
            -
          </Button>
          <InputNumber
            data-testid="column-input"
            value={inputValue.columns}
            min={0}
            max={MATRIX.COLUMN}
            precision={0}
            onChange={(value) => {
              value && setInputValue({ ...inputValue, columns: value });
            }}
            onKeyDown={(e: any) => {
              restrictToIntegersOnly(e);
            }}
            controls={false}
          />
          <Button
            data-testid="plus-button-columns"
            disabled={inputValue.columns >= MATRIX.COLUMN}
            onClick={() => {
              handleIncrement("columns");
            }}
          >
            +
          </Button>
        </div>
      </div>
    </Flex>
  );
};

export default RowColumn;
